import './Text.css';



export function KidsTable() {
  return (
    <div class="body">
            <div class="row" id="GalleryThree">
  <div class="column" >   
                    <h2> Kid's Table </h2><h4> 2025
                        <br/>
            Text.


</h4>
</div>


</div>

<div class="row" id="GalleryThree">
<div class="column">
<img src="Preach1.jpg"></img>
</div>
<div class="column">
<img src="Preach8.jpg"></img>
</div>
<div class="column">
<img src="Preach2.jpg"></img>
</div>
<div class="column">
<img src="Preach4.jpg"></img>
</div>
<div class="column">
<img src="Preach5.jpg"></img>
</div>
<div class="column">
<img src="Preach6.jpg"></img>
</div>
<div class="column">
<img src="Preach7.jpg"></img>
</div>
<div class="column">
<img src="Preach3.jpg"></img>
</div>
<div class="column">
<img src="Preach9.jpg"></img>
</div>
<div class="column">
<img src="Preach10.jpg"></img>
</div>
<div class="column">
<img src="Preach11.jpg"></img>
</div>
<div class="column">
<img src="Preach12.jpg"></img>
</div>
<div class="column">
<img src="Preach13.jpg"></img>
</div>
<div class="column">
<img src="Preach14.jpg"></img>
</div>
<div class="column">
<img src="Preach15.jpg"></img>
</div>
<div class="column">
<img src="Preach16.jpg"></img>
</div>
<div class="column">
<img src="Preach17.jpg"></img>
</div>
<div class="column">
<img src="Preach18.jpg"></img>
</div>
<div class="column">
<img src="Preach19.jpg"></img>
</div>
<div class="column">
<img src="Preach20.jpg"></img>
</div>
<div class="column">
<img src="Preach21.jpg"></img>
</div>
<div class="column">
<img src="Preach22.jpg"></img>
</div>
<div class="column">
<img src="Preach23.jpg"></img>
</div>
<div class="column">
<img src="Preach24.jpg"></img>
</div>
<div class="column">
<img src="Preach25.jpg"></img>
</div>
<div class="column">
<img src="Preach26.jpg"></img>
</div>
<div class="column">
<img src="Preach27.jpg"></img>
</div>


</div></div>


  );
}
